export const list = {
  REQUEST: 'Exercises/List/Request',
  SUCCESS: 'Exercises/List/Success',
  FAILURE: 'Exercises/List/Failure'
};

export const homePage = {
  REQUEST: 'Exercises/HomePage/Request',
  SUCCESS: 'Exercises/HomePage/Success',
  FAILURE: 'Exercises/HomePage/Failure'
};

export const terms = {
  REQUEST: 'Exercises/Terms/Request',
  SUCCESS: 'Exercises/Terms/Success',
  FAILURE: 'Exercises/Terms/Failure'
};

export const termsAccept = {
  REQUEST: 'Exercises/TermsAccept/Request',
  SUCCESS: 'Exercises/TermsAccept/Success',
  FAILURE: 'Exercises/TermsAccept/Failure'
};

export const changeCurrentExerciseId = {
  REQUEST: 'Exercises/changeCurrentExerciseId/Request',
  SUCCESS: 'Exercises/changeCurrentExerciseId/Success',
  FAILURE: 'Exercises/changeCurrentExerciseId/Failure'
};

export const exerciseStaticData = {
  REQUEST: 'Exercises/ForSubmit/Request',
  SUCCESS: 'Exercises/ForSubmit/Success',
  FAILURE: 'Exercises/ForSubmit/Failure'
};

export const exercisePost = {
  REQUEST: 'Exercises/Create/Request',
  SUCCESS: 'Exercises/Create/Success',
  FAILURE: 'Exercises/Create/Failure'
};

export const exercisePut = {
  REQUEST: 'Exercises/Update/Request',
  SUCCESS: 'Exercises/Update/Success',
  FAILURE: 'Exercises/Update/Failure'
};

export const exerciseGet = {
  REQUEST: 'Exercises/Get/Request',
  SUCCESS: 'Exercises/Get/Success',
  FAILURE: 'Exercises/Get/Failure',
  RESET: 'Exercises/Get/Reset'
};

export const CURRENT = {
  REQUEST: 'Exercises/Current/Request',
  SUCCESS: 'Exercises/Current/Success',
  FAILURE: 'Exercises/Current/Failure'
};

export const remainingDays = {
  REQUEST: 'RemainingDays/Get/Request',
  SUCCESS: 'RemainingDays/Get/Success',
  FAILURE: 'RemainingDays/Get/Failure'
};
